export default {
  name: 'notifications',

  getReducer(){
    const initialData = {
      options: null
    }

    return (state = initialData, { type, payload }) => {

      if(type === 'NOTIFICATIONS_FIRE'){
        return Object.assign({}, state, payload);
      }

      if(type === 'NOTIFICATIONS_CLEAR'){
        return Object.assign({}, state, { options: null });
      }

      if(payload && payload.notification){
        return Object.assign({}, state, {
          options: payload.notification
        })
      }

      return state;
    }
  },

  doFireNotification: (options) => ({ dispatch, payload }) => {
    dispatch({type: 'NOTIFICATIONS_FIRE', payload: { options } });
  },

  doClearNotification: () => ({ dispatch }) => {
    dispatch({type: 'NOTIFICATIONS_CLEAR'})
  },

  selectActiveNotification: (state) => {
    return state.notifications.options;
  }
}